import clsx from 'clsx';

export const SearchIcon = () => (
  <svg
    style={{ pointerEvents: 'none' }}
    className="absolute right-[12px] top-1/2 translate-y-[-50%]"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M9.49267 9.81188C10.3663 8.91891 10.9048 7.69678 10.9048 6.34887C10.9048 3.61374 8.68751 1.39648 5.95238 1.39648C3.21726 1.39648 1 3.61374 1 6.34887C1 9.08399 3.21726 11.3012 5.95238 11.3012C7.3396 11.3012 8.5936 10.7309 9.49267 9.81188ZM9.49267 9.81188L14 14.3965"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);

export const CaretIcon = ({ className }: { className?: string }) => (
  <svg
    style={{ pointerEvents: 'none' }}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44531 6.4004L9.72413 2.12159L10.8919 3.28938L5.44531 8.73599L-0.00129665 3.28938L1.1665 2.12159L5.44531 6.4004Z"
      fill="currentColor"
    />
  </svg>
);

export const MobileCollapsibleIcon = ({
  className,
  open,
}: {
  className?: string;
  open: boolean;
}) => (
  <>
    {open ? (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="11"
        viewBox="0 0 12 11"
        fill="none"
        className="lg:hidden"
      >
        <path
          d="M1.24219 0.396484L6.24219 5.39648M11.2422 10.3965L6.24219 5.39648M6.24219 5.39648L11.2422 0.396484M6.24219 5.39648L1.24219 10.3965"
          stroke="black"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="10"
        viewBox="0 0 12 10"
        fill="none"
        className="lg:hidden"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.68535 2.76603C3.68535 2.40286 3.9719 2.10875 4.32499 2.10875C4.67809 2.10875 4.96464 2.40286 4.96464 2.76603C4.96464 3.1292 4.67809 3.42392 4.32499 3.42392C3.9719 3.42392 3.68535 3.1292 3.68535 2.76603ZM6.1342 2.10875C5.87104 1.34233 5.16005 0.792969 4.32499 0.792969C3.48633 0.792969 2.77361 1.34666 2.51271 2.11738C2.47794 2.11183 2.44258 2.10875 2.40661 2.10875H1.12793C0.774833 2.10875 0.488281 2.40286 0.488281 2.76603C0.488281 3.1292 0.774833 3.42392 1.12793 3.42392H2.40661C2.44258 3.42392 2.47794 3.42084 2.51271 3.41468C2.77348 4.18602 3.48627 4.73909 4.32499 4.73909C5.16006 4.73909 5.87101 4.19032 6.1342 3.42393H11.3586C11.7117 3.42393 11.9983 3.1292 11.9983 2.76603C11.9983 2.40286 11.7117 2.10875 11.3586 2.10875L6.1342 2.10875ZM7.522 8.02792C7.522 7.66475 7.80855 7.37002 8.16164 7.37002C8.51474 7.37002 8.80129 7.66475 8.80129 8.02792C8.80129 8.39109 8.51474 8.6852 8.16164 8.6852C7.80855 8.6852 7.522 8.39109 7.522 8.02792ZM8.16164 6.05486C8.99671 6.05486 9.70766 6.60362 9.97085 7.37002H11.3586C11.7117 7.37002 11.9983 7.66475 11.9983 8.02792C11.9983 8.39109 11.7117 8.6852 11.3586 8.6852H9.97085C9.70769 9.45161 8.9967 10.001 8.16164 10.001C7.32659 10.001 6.61563 9.4516 6.35243 8.6852H1.12799C0.774896 8.6852 0.488344 8.39109 0.488344 8.02792C0.488344 7.66475 0.774896 7.37002 1.12799 7.37002H6.35243C6.6156 6.60361 7.32659 6.05486 8.16164 6.05486Z"
          fill="black"
        />
      </svg>
    )}
  </>
);

export const ChevronLeft = ({ className }: { className?: string }) => (
  <svg
    className={clsx('h-4 w-4', className)}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

export const ChevronRight = ({ className }: { className?: string }) => (
  <svg
    className={clsx('h-4 w-4', className)}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9 5l7 7-7 7"
    />
  </svg>
);

export const FlagIcon = ({ className }: { className?: string }) => (
  <svg fill="none" viewBox="0 0 11 10" className={className}>
    <path fill="#7A7A7A" d="M.785 5.215 7.858 1.13v8.167L.785 5.215Z" />
  </svg>
);

export const CalendarIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 25 25" className={clsx(className, 'fill-current')}>
    <g clipPath="url(#cal)">
      <path
        d="M18 5.354h3.6v18H2.4v-18H6v-1.2c0-.492.18-.912.528-1.272A1.75 1.75 0 0 1 7.8 2.354c.492 0 .924.18 1.272.528.348.36.528.78.528 1.272v1.2h4.8v-1.2c0-.492.18-.912.528-1.272a1.75 1.75 0 0 1 1.272-.528c.492 0 .924.18 1.272.528.348.36.528.78.528 1.272v1.2Zm-10.8-1.2v3c0 .168.06.312.18.432a.58.58 0 0 0 .42.168.58.58 0 0 0 .42-.168.59.59 0 0 0 .18-.432v-3a.545.545 0 0 0-.18-.42.545.545 0 0 0-.42-.18.545.545 0 0 0-.42.18.545.545 0 0 0-.18.42Zm8.4 0v3c0 .168.06.312.168.432.12.108.264.168.432.168.168 0 .312-.06.432-.168a.629.629 0 0 0 .168-.432v-3a.58.58 0 0 0-.168-.42.59.59 0 0 0-.432-.18.59.59 0 0 0-.432.18.58.58 0 0 0-.168.42Zm4.8 18v-12H3.6v12h16.8Zm-12-10.8v2.4H6v-2.4h2.4Zm2.4 0h2.4v2.4h-2.4v-2.4Zm4.8 2.4v-2.4H18v2.4h-2.4Zm-7.2 1.2v2.4H6v-2.4h2.4Zm2.4 0h2.4v2.4h-2.4v-2.4Zm4.8 2.4v-2.4H18v2.4h-2.4Zm-7.2 1.2v2.4H6v-2.4h2.4Zm4.8 2.4h-2.4v-2.4h2.4v2.4Zm4.8 0h-2.4v-2.4H18v2.4Z"
        fill="#000"
      />
    </g>
    <defs>
      <clipPath id="cal">
        <path fill="#fff" transform="translate(0 .553)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const AddToCalendarIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 25 25" className={clsx(className, 'fill-current')}>
    <g clipPath="url(#add-to-cal)">
      <path d="M18.834 5.3h3.6v18h-19.2v-18h3.6V4.1c0-.491.18-.911.528-1.271A1.75 1.75 0 0 1 8.634 2.3c.492 0 .924.18 1.272.528.348.36.528.78.528 1.272v1.2h4.8V4.1c0-.492.18-.912.528-1.272a1.75 1.75 0 0 1 1.272-.528c.492 0 .924.18 1.272.528.348.36.528.78.528 1.272v1.2Zm-10.8-1.2v3c0 .169.06.313.18.433a.58.58 0 0 0 .42.168.58.58 0 0 0 .42-.168.59.59 0 0 0 .18-.432v-3a.545.545 0 0 0-.18-.42.545.545 0 0 0-.42-.18.545.545 0 0 0-.42.18.545.545 0 0 0-.18.42Zm8.4 0v3c0 .169.06.313.168.433.12.108.264.168.432.168.168 0 .312-.06.432-.168a.629.629 0 0 0 .168-.432v-3a.58.58 0 0 0-.168-.42.59.59 0 0 0-.432-.18.59.59 0 0 0-.432.18.58.58 0 0 0-.168.42Zm4.8 18v-12h-16.8v12h16.8Z" />
      <path d="M16.635 15.142v1.433h-7v-1.433h7Zm-2.68-2.695v7h-1.634v-7h1.634Z" />
    </g>
    <defs>
      <clipPath id="add-to-cal">
        <path d="M0 0h24v24H0z" transform="translate(.834 .5)" />
      </clipPath>
    </defs>
  </svg>
);

export const InfoIcon = ({ className }: { className?: string }) => (
  <svg fill="none" viewBox="0 0 17 17" className={className}>
    <path
      stroke="#fff"
      strokeWidth="1.533"
      d="M15.4 8.5c0 3.918-3.104 7.066-6.9 7.066-3.795 0-6.9-3.148-6.9-7.067 0-3.918 3.105-7.066 6.9-7.066 3.796 0 6.9 3.148 6.9 7.066Z"
    />
    <path
      fill="#fff"
      stroke="#fff"
      strokeWidth=".3"
      d="M6.334 6.435h-.15v1.086h1.797v3.416H6.184v1.081h4.724v-1.081H9.184V6.435h-2.85Zm1.574-1.51-.002.006a.84.84 0 0 0-.042.267c0 .18.054.338.17.467l.002.002c.129.138.312.194.52.194.206 0 .386-.057.515-.194a.666.666 0 0 0 .177-.469.776.776 0 0 0-.05-.278.573.573 0 0 0-.154-.227.57.57 0 0 0-.211-.128.753.753 0 0 0-.277-.049.79.79 0 0 0-.281.048.614.614 0 0 0-.367.36Z"
    />
  </svg>
);

export const EspnIcon = ({ className }: { className?: string }) => (
  <svg fill="none" viewBox="0 0 49 13" className={className}>
    <g clipPath="url(#espn)">
      <path
        fill="#fff"
        d="M16.024.531c-1.786-.002-2.968.95-3.135 2.372-.038.329-.078.658-.12.986h23.233l.077-.625c.175-1.433-.428-2.733-2.619-2.733H16.024Zm-14.178 0L1.438 3.89h10.536L12.38.532H1.845Zm35.366 0-.407 3.358h11.421s.014-.121.065-.516c.278-2.204-1.129-2.841-2.486-2.841h-8.593Zm-.565 4.637-.89 7.327 3.941-.001.89-7.325-3.94-.002Zm7.486 0-.891 7.327 3.94-.001.891-7.325-3.94-.002Zm-42.849 0-.891 7.327h10.535l.388-3.178H4.719l.167-1.371h6.594l.338-2.777H1.285Zm11.33 0c-.288 1.913.659 2.777 2 2.777l5.33-.002-.165 1.373h-7.667l-.386 3.18s8.346.002 8.685 0c.279-.021 2.232-.075 2.896-1.69.216-.524.407-2.403.46-2.798.307-2.291-1.262-2.837-2.498-2.837l-8.654-.002Zm12.265 0-.89 7.327h3.939l.554-4.55h4.947c1.403 0 2.157-.762 2.297-1.786.045-.33.086-.66.122-.99H24.879Z"
      />
    </g>
    <defs>
      <clipPath id="espn">
        <path fill="#fff" d="M0 0h48v12H0z" transform="translate(.834 .5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SlingIcon = ({ className }: { className?: string }) => (
  <svg fill="none" viewBox="0 0 42 22" className={className}>
    <g fill="#fff" clipPath="url(#a)">
      <path d="M11.132 3.589v13.916c0 .095.075.17.17.17h2.35a.17.17 0 0 0 .17-.17V3.588a.17.17 0 0 0-.17-.171h-2.35a.17.17 0 0 0-.17.17Zm-7.35 6.662c0-.454.636-.78 1.61-.78 1.109 0 2.154.394 2.802.95.12.104.306.072.386-.067l.79-1.578a.245.245 0 0 0-.063-.314C8.33 7.727 7.01 7.198 5.372 7.198c-2.687 0-4.193 1.502-4.193 3.22 0 4.002 6.077 2.619 6.077 4.38 0 .48-.548.89-1.713.89-1.157 0-2.524-.457-3.319-1.09a.252.252 0 0 0-.374.068l-.902 1.499a.244.244 0 0 0 .048.314c1.085.91 2.723 1.45 4.416 1.45 2.838 0 4.424-1.398 4.424-3.278.004-4.039-6.054-2.79-6.054-4.4Zm11.905-2.886v10.132c0 .095.075.17.17.17h2.35a.17.17 0 0 0 .17-.17V7.365a.17.17 0 0 0-.17-.171h-2.35c-.091.004-.17.08-.17.17Zm11.447 10.132c0 .095.075.17.17.17h2.35a.17.17 0 0 0 .17-.17v-6.63c0-1.992-1.454-3.689-3.7-3.689-1.673 0-2.802.843-3.207 1.59V7.365a.17.17 0 0 0-.171-.171h-2.35a.17.17 0 0 0-.17.17v10.133c0 .095.075.17.17.17h2.35a.17.17 0 0 0 .17-.17v-5.561c0-1.24.91-2.357 2.199-2.357 1.097 0 2.015.568 2.015 1.987v5.93h.004Zm4.595 2.853a.17.17 0 0 0 .031.219c1.24 1.05 2.588 1.43 4.297 1.43 2.52 0 5.529-1.132 5.529-5.031V7.603a.17.17 0 0 0-.171-.17h-2.373a.17.17 0 0 0-.17.17v1.145c-.665-1.081-1.81-1.566-3.038-1.566-2.583 0-4.634 2.19-4.634 5.537 0 2.782 1.952 5.21 4.634 5.21 1.268 0 2.23-.591 3.037-1.609v.715c0 2.012-1.526 2.767-2.818 2.767-1.216 0-2.246-.318-3.052-1.117a.17.17 0 0 0-.263.032l-1.01 1.633Zm4.837-5.139c-1.526 0-2.584-1.03-2.584-2.786 0-1.757 1.062-2.85 2.584-2.85 1.395 0 2.31 1.32 2.31 2.85s-.911 2.786-2.31 2.786ZM15.427 3.153a1.63 1.63 0 0 1 1.65-1.614 1.63 1.63 0 0 1 1.613 1.65 1.646 1.646 0 0 1-1.65 1.613 1.643 1.643 0 0 1-1.613-1.65ZM20.49 4.91c.816-.192 1.428-.895 1.44-1.746v-.012c.004-.85-.593-1.57-1.403-1.776-.08-.02-.175.027-.124.127.334.588.414 1.212.41 1.645-.004.43-.1 1.054-.445 1.634-.052.095.04.147.123.127Zm3.062.693c1.14-.262 1.991-1.248 2.011-2.437V3.15c.004-1.188-.826-2.19-1.96-2.48-.115-.028-.246.04-.17.175.465.819.58 1.693.572 2.294-.008.6-.143 1.474-.624 2.281-.071.14.056.21.171.183ZM26.835.23c.588 1.038.736 2.147.728 2.906-.008.763-.18 1.864-.791 2.89-.096.167.067.306.21.274 1.443-.334 2.524-1.63 2.548-3.132v-.02c.008-1.502-1.045-2.774-2.48-3.14-.14-.036-.306.052-.215.223Z" />
    </g>
    <defs>
      <clipPath id="sling">
        <path fill="#fff" d="M0 0h40.678v22H0z" transform="translate(.911)" />
      </clipPath>
    </defs>
  </svg>
);

export const FuboIcon = ({ className }: { className?: string }) => (
  <svg fill="none" viewBox="0 0 45 18" className={className}>
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m1.07 7.625.63-3.08 1.76.039C3.994 1.231 6.209-.055 9.986.45l-.578 3.067-1.418-.026c-.702.027-1.077.412-1.182 1.093l1.839-.012-.578 3.041-1.878.027-1.904 9.716-3.296.013L2.87 7.612l-1.799.013ZM9.726 4.44h3.467l-1.327 6.846c-.262 1.449-.538 3.055 1.182 3.358.478.069.968 0 1.433-.218 1.4-.657 1.74-2.05 2.024-3.446l1.323-6.527 3.322-.012-2.547 12.837-3.047.04.132-.632c-2.027 1.34-4.49 1.16-5.96.187-1.428-1.01-1.754-2.778-1.396-5.016L9.726 4.44ZM19.73 17.317l3.256-.012.197-1.04c2 2.168 6.574 1.453 8.168.026-.878-.901-1.25-1.972-1.392-3.12-1.134 1.484-3.358 1.664-4.504.777-1.077-.768-1.356-2.297-1.076-3.623.253-1.197 1.037-2.257 2.182-2.718 1.356-.545 2.98-.196 3.778.864 1.343 2.19.264 4.012 1.203 5.974.559 1.168 1.662 2.16 2.835 2.666 1.411.61 3.136.727 4.732.262 1.875-.547 3.416-1.9 4.266-3.654 1.011-2.087 1.082-4.663.021-6.6-1.757-3.205-6.533-3.988-9.485-1.716.743.923 1.078 1.978 1.313 3.094 1.226-1.624 3.594-1.43 4.701-.448.95.84 1.215 2.8.503 4.345-.553 1.197-1.561 1.844-2.835 2.042-2.243.348-3.442-1.463-3.55-3.345-.026-1.88-.177-3.233-.869-4.326-.475-.753-1.245-1.439-2.034-1.845-1.706-.88-4.106-.943-5.764.088l.88-4.53-3.27-.012-3.256 16.851Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fubo">
        <path fill="#fff" d="M0 0h43.499v18H0z" transform="translate(.589)" />
      </clipPath>
    </defs>
  </svg>
);
